export class NovaInterpolator {
  type = 'i18nFormat';

  // The escape logic is unused since our default configuration for i18next turned off escaping values.
  // Leaving this in place in case that changes or a consumer configures i18next to turn it on.
  // Since the default is to not use it (and would be rare to do so), we also don't have unit tests to verify it.
  entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
  };
  escape(data) {
    return data.replace(/[&<>"'\/]/g, s => this.entityMap[s]);
  }
  parse(rawMessage, options, _language, _bundleName, _key) {
    // Split on placeholders but not ones that have '\' in between the {}'s.
    const messageSplitter = /({[^{}\\}]*})/;
    const parts = rawMessage.split(messageSplitter);
    const placeholderTest = /^\{(.*)\}$/; // Starts with '{' and ends with '}'.
    return parts.map(part => {
      const placeholderMatch = placeholderTest.exec(part);
      if (placeholderMatch) {
        const replacement = options[placeholderMatch[1]?.trim()];
        if (replacement === null) return 'null';
        if (replacement === undefined) return 'undefined';
        return replacement;
      }
      const espacedRegex = /\\\\([{}])/g;
      return part.replace(espacedRegex, '$1') // Replace escaped {'s and }'s.
      .replace('\\\\', '\\') // Replace other escaped characters.
      .replace(/\\n/g, '\n'); // Convert newline sequence to an actual newline.
    }).join('');
  }
}
//# sourceMappingURL=NovaInterpolator.js.map